<template>
  <v-autocomplete
    v-model="map_id"
    :items="mapIds"
    :hint="createdAtHint"
    label="Map ID"
    background-color="grey lighten-1"
    class="pt-1"
    clearable
    dense
    solo
    flat
    persistent-hint
    item-text="alias"
    item-value="mapId"
    hide-detailse="auto"
  />
</template>

<script>
export default {
  name: 'MapIdAutocomplete',
  props: {
    value: {
      type: [String, Number, null],
      default: null
    }
  },
  data () {
    return {
      map_id: this.value,
      mapIds: []
    }
  },
  watch: {
    map_id (newVal) {
      this.$emit('input', newVal)
    },
    value (newVal) {
      this.map_id = newVal
    }
  },
  computed: {
    createdAtHint () {
      const val = this.mapIds.find(mapId => mapId.mapId === this.map_id)
      if (val) {
        return val.createdAt
      } else {
        return ''
      }
    }
  },
  async mounted () {
    const { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/multi-map')
    .catch(error => ({ data: { err: true, message: error.response.data } }))

    if (data.err) {
      this.$toasted.error(data.message)
    } else {
      this.mapIds = data

      if (this.$route.query.map_id) {
        this.map_id = this.$route.query.map_id
      } else if (data.length) {
        this.map_id = data[0].mapId
      }
    }
  }
}
</script>